import { useContext } from 'react';
import { WizardContext } from '../wizard/WizardContext';
import type { WizardStep } from '../wizard/wizardTypes';
import IdVerificationContext from '../IdvContext';
import { useIsFetching, useIsMutating } from '@zg-rentals/react-query5';
import { Box, Divider, LoadingMask, Modal, ToastProvider } from '@zillow/constellation-10';
import Header from './Header';
import InitializeWizard from './InitializeWizard';
import Footer from './Footer';
import {
  wizardBodyStyles,
  wizardContainerStyles,
  wizardStepGridStyles,
  wizardStepGridWithTipStyles,
} from './wizardShellStyles';

const WIZARD_TITLE_ID = 'id-verification-wizard-title';

export function WizardContent() {
  const { currentStep } = useContext(WizardContext);
  const { hasInitializedWizard, isOnExitLoading } = useContext(IdVerificationContext);
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isBusy = Boolean(isFetching || isMutating || isOnExitLoading);
  const Tip = (currentStep as WizardStep).Tip;

  return (
    <Modal.Root open size="fullScreen" useDismissProps={{ escapeKey: false, outsidePress: false }}>
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content aria-labelledby={WIZARD_TITLE_ID} css={{ overflow: 'hidden', height: '100%' }}>
            <Header titleId={WIZARD_TITLE_ID} />
            <Divider />
            <Modal.Body css={wizardBodyStyles}>
              <ToastProvider>
                <LoadingMask loading={!hasInitializedWizard} css={{ display: 'block', minHeight: '100%' }}>
                  <Box css={wizardContainerStyles}>
                    <Box css={{ ...wizardStepGridStyles, ...(Tip ? wizardStepGridWithTipStyles : {}) }}>
                      <Box>{!hasInitializedWizard ? <InitializeWizard /> : <currentStep.Component />}</Box>
                      {Tip && (
                        <Box>
                          <Tip />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </LoadingMask>
              </ToastProvider>
            </Modal.Body>
            <Divider />
            <Footer isInitializing={!hasInitializedWizard} isBusy={isBusy} />
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
}
